module.exports = __webpack_public_path__ + "img/5.e2b18d0b.jpg";